import React from 'react';
import { useWeb3 } from '../contexts/Web3Context';
import { Wallet, AlertCircle, CheckCircle } from 'lucide-react';
import { Button } from './ui/button';
import { formatAddress } from '../utils/contracts';

export const WalletConnect = () => {
  const { account, balance, isConnecting, error, connectWallet, disconnectWallet, isConnected, isCorrectNetwork } = useWeb3();

  if (isConnected) {
    return (
      <div data-testid="wallet-connected" className="flex items-center gap-3">
        <div className="hidden md:flex flex-col items-end">
          <div className="text-sm font-mono font-semibold text-slate-900">{formatAddress(account)}</div>
          <div className="text-xs text-slate-500">{parseFloat(balance).toFixed(4)} ETH</div>
        </div>
        {!isCorrectNetwork && (
          <div data-testid="wrong-network-warning" className="flex items-center gap-1 text-xs text-amber-700 bg-amber-50 px-2 py-1 rounded-md border border-amber-200">
            <AlertCircle className="h-3 w-3" />
            <span>Wrong Network</span>
          </div>
        )}
        <Button
          data-testid="disconnect-wallet-button"
          onClick={disconnectWallet}
          variant="outline"
          size="sm"
          className="font-semibold border-slate-300 hover:border-red-500 hover:text-red-600"
        >
          <Wallet className="mr-2 h-4 w-4" />
          Disconnect
        </Button>
      </div>
    );
  }

  return (
    <div data-testid="wallet-connect-container">
      <Button
        data-testid="connect-wallet-button"
        onClick={connectWallet}
        disabled={isConnecting}
        className="gradient-bg text-white hover:opacity-90 font-semibold button-scale shadow-lg shadow-indigo-500/30"
      >
        <Wallet className="mr-2 h-4 w-4" />
        {isConnecting ? 'Connecting...' : 'Connect Wallet'}
      </Button>
      {error && (
        <div data-testid="wallet-error" className="mt-2 text-xs text-red-600 flex items-center gap-1">
          <AlertCircle className="h-3 w-3" />
          {error}
        </div>
      )}
    </div>
  );
};